import './catalog-menu.less';
import { globalState } from 'globalState/global-state.js';
import { createApp } from 'vue';
import App from './App.vue';
import { createStore } from 'vuex';

const store = createStore({
    state: {
        menulist: {
            id: 0,
            name: 'Каталог товаров',
            level: 0,
            childrens: [
                {
                    id: 1,
                    name: 'Загрузка',
                    level: 1,
                },
            ],
        },
        level1: {
            list: null,
            isCatalog: false,
            parentUrl: null,
        },
        level2: {
            list: null,
            isCatalog: false,
            parentUrl: null,
        },
        level3: {
            list: null,
            isCatalog: false,
            parentUrl: null,
        },
    },
    mutations: {
        updateList(state, payload) {
            state.menulist = payload;
        },
        updateLevel(state, payload) {
            var level = 'level' + Number(payload.thislevel);
            state[level].list = payload.list ? payload.list : null;
            state[level].isCatalog = payload.isCatalog;
            state[level].parentUrl = payload.parentUrl;
        },
        clearLevel(state) {
            state.level1 = {
                list: null,
                isCatalog: false,
            };
            state.level2 = {
                list: null,
                isCatalog: false,
            };
            state.level3 = {
                list: null,
                isCatalog: false,
            };
        },
    },
    actions: {
        getList() {
            globalState.getMenu().then(function (result) {
                store.commit('updateList', result);
            });
        },
    },
});

createApp(App).use(store).mount('#catalog-app');
